
import { defineComponent } from 'vue';

import * as Constants from '@/constants';

export default defineComponent({
  name: 'Calendly',

  emits: ['success'],

  data() {
    return {
      unRegisterEventForCalendly: null as unknown as () => void,
    };
  },

  computed: {
    campaign(): string | undefined {
      return this.$store.state.campaign?.calendlyUrl;
    },
  },

  mounted() {
    this.initCalendly();
  },

  unmounted() {
    if (this.unRegisterEventForCalendly) {
      this.unRegisterEventForCalendly();
    }
  },

  methods: {
    initCalendly() {
      const calendlyStyleParams = this.getCalendlyURLParams();

      let campaignUrl = this.campaign;

      if (process.env.VUE_APP_CALENDLY_URL) {
        campaignUrl = process.env.VUE_APP_CALENDLY_URL;
      }

      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      (window as unknown as { Calendly: any}).Calendly.initInlineWidget({
        url: `${campaignUrl}?${calendlyStyleParams}`,
        parentElement: this.$refs.calendly,
        prefill: this.getPreFillParamsForCalendly(),
        utm: {},
      });

      const onMessage = (event: MessageEvent) => {
        this.onSuccess(event);
      };

      const unRegisterEvent = () => {
        window.removeEventListener('message', onMessage);
      };

      this.unRegisterEventForCalendly = unRegisterEvent;

      window.addEventListener('message', onMessage);
    },

    onSuccess(event: MessageEvent) {
      if (this.isCalendlyEvent(event)) {
        if (event.data.event === 'calendly.event_scheduled') {
          this.$emit('success');
        }
      }
    },

    getPreFillParamsForCalendly() {
      let phoneNumber = '';
      let age = '';

      if (this.$store.state.yourdata?.telephoneNumber) {
        phoneNumber = `${this.$store.state.yourdata?.countryCode} ${this.$store.state.yourdata?.telephoneNumber}`;
      }

      if (this.$store.state.yourdata?.age) {
        age = `${this.$store.state.yourdata?.age}`;
      }

      return {
        name: this.$store.state.yourdata?.name,
        email: this.$store.state.yourdata?.emailAddress,
        customAnswers: {
          a1: phoneNumber,
          a2: age,
          a3: '1,2',
        },
      };
    },

    getCalendlyURLParams() {
      return [
        'hide_event_type_details=1',
        'hide_landing_page_details=1',
        'hide_gdpr_banner=1',
        'primary_color=d21342',
        'accent_color=d21342',
      ].join('&');
    },

    isCalendlyEvent(e: MessageEvent) {
      return e.data.event
        && e.data.event.indexOf('calendly') === 0;
    },
  },
});
